import { useQuery } from "@apollo/client";
import { Spinner, Table } from "evergreen-ui";
import styled from "styled-components";
import React from "react";
import Message from "src/Message";
import { GET_CASH_TRANSACTIONS } from "src/Queries/users.shared";
import { getDateWithTime } from "src/utilities";

const LoadingContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 50vh;
`;
interface IProps {
  id: string;
}
const CashHistory: React.SFC<IProps> = ({ id }) => {
  const { data, loading, error } = useQuery(GET_CASH_TRANSACTIONS, {
    variables: {
      id,
    },
  });

  if (!loading && data && data.cash_transactions) {
    return data.cash_transactions.length > 0 ? (
      <Table maxWidth="100vw" overflow="auto">
        <Table.Head minWidth="768px">
          <Table.TextHeaderCell>Created Date</Table.TextHeaderCell>
          <Table.TextHeaderCell>Description</Table.TextHeaderCell>
          <Table.TextHeaderCell>Amount</Table.TextHeaderCell>
          <Table.TextHeaderCell>Closing Balance</Table.TextHeaderCell>
          <Table.TextHeaderCell>Opening Balance</Table.TextHeaderCell>
        </Table.Head>
        <Table.Body minWidth="768px">
          {data.cash_transactions.map((rec, index) => (
            <Table.Row
              height="auto"
              key={index}
              paddingY={12}
              style={{ whiteSpace: "normal", wordWrap: "break-word" }}
            >
              <Table.TextCell
                style={{ whiteSpace: "normal", wordWrap: "break-word" }}
              >
                {getDateWithTime(rec.created_at)}
              </Table.TextCell>
              <Table.TextCell width="140px">
                <p
                  style={{
                    whiteSpace: "break-spaces",
                    textOverflow: "break-word",
                    overflowWrap: "break-word",
                    wordWrap: "normal",
                    width: "140px",
                  }}
                >
                  {rec.message}
                </p>
              </Table.TextCell>
              <Table.TextCell
                style={{ whiteSpace: "normal", wordWrap: "break-word" }}
              >
                {rec.transaction_amount}
              </Table.TextCell>
              <Table.TextCell
                style={{ whiteSpace: "normal", wordWrap: "break-word" }}
              >
                {rec.closing_balance}
              </Table.TextCell>
              <Table.TextCell
                style={{ whiteSpace: "normal", wordWrap: "break-word" }}
              >
                {rec.opening_balance}
              </Table.TextCell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    ) : (
      <Message label="No record found. You may find the related record in Cash Pending." />
    );
  }

  if (!loading && error) {
    return <Message label={"Error: " + error.message} />;
  }

  return (
    <LoadingContainer>
      <Spinner />
    </LoadingContainer>
  );
};

export default CashHistory;
